const COUNTRIES = [
  { label: 'Afghanistan', value: 'Afghanistan', icon: '🇦🇫' },
  { label: 'Albania', value: 'Albania', icon: '🇦🇱' },
  { label: 'Algeria', value: 'Algeria', icon: '🇩🇿' },
  { label: 'Andorra', value: 'Andorra', icon: '🇦🇩' },
  { label: 'Angola', value: 'Angola', icon: '🇦🇴' },
  { label: 'Antigua and Barbuda', value: 'Antigua and Barbuda', icon: '🇦🇬' },
  { label: 'Argentina', value: 'Argentina', icon: '🇦🇷' },
  { label: 'Armenia', value: 'Armenia', icon: '🇦🇲' },
  { label: 'Australia', value: 'Australia', icon: '🇦🇺' },
  { label: 'Austria', value: 'Austria', icon: '🇦🇹' },
  { label: 'Azerbaijan', value: 'Azerbaijan', icon: '🇦🇿' },
  { label: 'The Bahamas', value: 'The Bahamas', icon: '🇧🇸' },
  { label: 'Bahrain', value: 'Bahrain', icon: '🇧🇭' },
  { label: 'Bangladesh', value: 'Bangladesh', icon: '🇧🇩' },
  { label: 'Barbados', value: 'Barbados', icon: '🇧🇧' },
  { label: 'Belarus', value: 'Belarus', icon: '🇧🇾' },
  { label: 'Belgium', value: 'Belgium', icon: '🇧🇪' },
  { label: 'Belize', value: 'Belize', icon: '🇧🇿' },
  { label: 'Benin', value: 'Benin', icon: '🇧🇯' },
  { label: 'Bhutan', value: 'Bhutan', icon: '🇧🇹' },
  { label: 'Bolivia', value: 'Bolivia', icon: '🇧🇴' },
  { label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina', icon: '🇧🇦' },
  { label: 'Botswana', value: 'Botswana', icon: '🇧🇼' },
  { label: 'Brazil', value: 'Brazil', icon: '🇧🇷' },
  { label: 'Brunei', value: 'Brunei', icon: '🇧🇳' },
  { label: 'Bulgaria', value: 'Bulgaria', icon: '🇧🇬' },
  { label: 'Burkina Faso', value: 'Burkina Faso', icon: '🇧🇫' },
  { label: 'Burundi', value: 'Burundi', icon: '🇧🇮' },
  { label: 'Cabo Verde', value: 'Cabo Verde', icon: '🇨🇻' },
  { label: 'Cambodia', value: 'Cambodia', icon: '🇰🇭' },
  { label: 'Cameroon', value: 'Cameroon', icon: '🇨🇲' },
  { label: 'Canada', value: 'Canada', icon: '🇨🇦' },
  { label: 'Central African Republic', value: 'Central African Republic', icon: '🇨🇫' },
  { label: 'Chad', value: 'Chad', icon: '🇹🇩' },
  { label: 'Chile', value: 'Chile', icon: '🇨🇱' },
  { label: 'China', value: 'China', icon: '🇨🇳' },
  { label: 'Colombia', value: 'Colombia', icon: '🇨🇴' },
  { label: 'Comoros', value: 'Comoros', icon: '🇰🇲' },
  { label: 'Congo, Democratic Republic of the Congo', value: 'Congo, Democratic Republic of the Congo', icon: '🇨🇩' },
  { label: 'Congo, Republic of the Congo', value: 'Congo, Republic of the Congo', icon: '🇨🇬' },
  { label: 'Costa Rica', value: 'Costa Rica', icon: '🇨🇷' },
  { label: 'Côte d’Ivoire', value: 'Côte d’Ivoire', icon: '🇨🇮' },
  { label: 'Croatia', value: 'Croatia', icon: '🇭🇷' },
  { label: 'Cuba', value: 'Cuba', icon: '🇨🇺' },
  { label: 'Cyprus', value: 'Cyprus', icon: '🇨🇾' },
  { label: 'Czech Republic', value: 'Czech Republic', icon: '🇨🇿' },
  { label: 'Denmark', value: 'Denmark', icon: '🇩🇰' },
  { label: 'Djibouti', value: 'Djibouti', icon: '🇩🇯' },
  { label: 'Dominica', value: 'Dominica', icon: '🇩🇲' },
  { label: 'Dominican Republic', value: 'Dominican Republic', icon: '🇩🇴' },
  { label: 'East Timor (Timor-Leste)', value: 'East Timor (Timor-Leste)', icon: '🇹🇱' },
  { label: 'Ecuador', value: 'Ecuador', icon: '🇪🇨' },
  { label: 'Egypt', value: 'Egypt', icon: '🇪🇬' },
  { label: 'El Salvador', value: 'El Salvador', icon: '🇸🇻' },
  { label: 'Equatorial Guinea', value: 'Equatorial Guinea', icon: '🇬🇶' },
  { label: 'Eritrea', value: 'Eritrea', icon: '🇪🇷' },
  { label: 'Estonia', value: 'Estonia', icon: '🇪🇪' },
  { label: 'Eswatini', value: 'Eswatini', icon: '🇸🇿' },
  { label: 'Ethiopia', value: 'Ethiopia', icon: '🇪🇹' },
  { label: 'Fiji', value: 'Fiji', icon: '🇫🇯' },
  { label: 'Finland', value: 'Finland', icon: '🇫🇮' },
  { label: 'France', value: 'France', icon: '🇫🇷' },
  { label: 'Gabon', value: 'Gabon', icon: '🇬🇦' },
  { label: 'The Gambia', value: 'The Gambia', icon: '🇬🇲' },
  { label: 'Georgia', value: 'Georgia', icon: '🇬🇪' },
  { label: 'Germany', value: 'Germany', icon: '🇩🇪' },
  { label: 'Ghana', value: 'Ghana', icon: '🇬🇭' },
  { label: 'Greece', value: 'Greece', icon: '🇬🇷' },
  { label: 'Grenada', value: 'Grenada', icon: '🇬🇩' },
  { label: 'Guatemala', value: 'Guatemala', icon: '🇬🇹' },
  { label: 'Guinea', value: 'Guinea', icon: '🇬🇳' },
  { label: 'Guinea-Bissau', value: 'Guinea-Bissau', icon: '🇬🇼' },
  { label: 'Guyana', value: 'Guyana', icon: '🇬🇾' },
  { label: 'Haiti', value: 'Haiti', icon: '🇭🇹' },
  { label: 'Honduras', value: 'Honduras', icon: '🇭🇳' },
  { label: 'Hungary', value: 'Hungary', icon: '🇭🇺' },
  { label: 'Iceland', value: 'Iceland', icon: '🇮🇸' },
  { label: 'India', value: 'India', icon: '🇮🇳' },
  { label: 'Indonesia', value: 'Indonesia', icon: '🇮🇩' },
  { label: 'Iran', value: 'Iran', icon: '🇮🇷' },
  { label: 'Iraq', value: 'Iraq', icon: '🇮🇶' },
  { label: 'Ireland', value: 'Ireland', icon: '🇮🇪' },
  { label: 'Israel', value: 'Israel', icon: '🇮🇱' },
  { label: 'Italy', value: 'Italy', icon: '🇮🇹' },
  { label: 'Jamaica', value: 'Jamaica', icon: '🇯🇲' },
  { label: 'Japan', value: 'Japan', icon: '🇯🇵' },
  { label: 'Jordan', value: 'Jordan', icon: '🇯🇴' },
  { label: 'Kazakhstan', value: 'Kazakhstan', icon: '🇰🇿' },
  { label: 'Kenya', value: 'Kenya', icon: '🇰🇪' },
  { label: 'Kiribati', value: 'Kiribati', icon: '🇰🇮' },
  { label: 'Korea, North', value: 'Korea, North', icon: '🇰🇵' },
  { label: 'Korea, South', value: 'Korea, South', icon: '🇰🇷' },
  { label: 'Kosovo', value: 'Kosovo', icon: '🇽🇰' },
  { label: 'Kuwait', value: 'Kuwait', icon: '🇰🇼' },
  { label: 'Kyrgyzstan', value: 'Kyrgyzstan', icon: '🇰🇬' },
  { label: 'Laos', value: 'Laos', icon: '🇱🇦' },
  { label: 'Latvia', value: 'Latvia', icon: '🇱🇻' },
  { label: 'Lebanon', value: 'Lebanon', icon: '🇱🇧' },
  { label: 'Lesotho', value: 'Lesotho', icon: '🇱🇸' },
  { label: 'Liberia', value: 'Liberia', icon: '🇱🇷' },
  { label: 'Libya', value: 'Libya', icon: '🇱🇾' },
  { label: 'Liechtenstein', value: 'Liechtenstein', icon: '🇱🇮' },
  { label: 'Lithuania', value: 'Lithuania', icon: '🇱🇹' },
  { label: 'Luxembourg', value: 'Luxembourg', icon: '🇱🇺' },
  { label: 'Madagascar', value: 'Madagascar', icon: '🇲🇬' },
  { label: 'Malawi', value: 'Malawi', icon: '🇲🇼' },
  { label: 'Malaysia', value: 'Malaysia', icon: '🇲🇾' },
  { label: 'Maldives', value: 'Maldives', icon: '🇲🇻' },
  { label: 'Mali', value: 'Mali', icon: '🇲🇱' },
  { label: 'Malta', value: 'Malta', icon: '🇲🇹' },
  { label: 'Marshall Islands', value: 'Marshall Islands', icon: '🇲🇭' },
  { label: 'Mauritania', value: 'Mauritania', icon: '🇲🇷' },
  { label: 'Mauritius', value: 'Mauritius', icon: '🇲🇺' },
  { label: 'Mexico', value: 'Mexico', icon: '🇲🇽' },
  { label: 'Micronesia', value: 'Micronesia', icon: '🇫🇲' },
  { label: 'Moldova', value: 'Moldova', icon: '🇲🇩' },
  { label: 'Monaco', value: 'Monaco', icon: '🇲🇨' },
  { label: 'Mongolia', value: 'Mongolia', icon: '🇲🇳' },
  { label: 'Montenegro', value: 'Montenegro', icon: '🇲🇪' },
  { label: 'Morocco', value: 'Morocco', icon: '🇲🇦' },
  { label: 'Mozambique', value: 'Mozambique', icon: '🇲🇿' },
  { label: 'Myanmar (Burma)', value: 'Myanmar (Burma)', icon: '🇲🇲' },
  { label: 'Namibia', value: 'Namibia', icon: '🇳🇦' },
  { label: 'Nauru', value: 'Nauru', icon: '🇳🇷' },
  { label: 'Nepal', value: 'Nepal', icon: '🇳🇵' },
  { label: 'Netherlands', value: 'Netherlands', icon: '🇳🇱' },
  { label: 'New Zealand', value: 'New Zealand', icon: '🇳🇿' },
  { label: 'Nicaragua', value: 'Nicaragua', icon: '🇳🇮' },
  { label: 'Niger', value: 'Niger', icon: '🇳🇪' },
  { label: 'Nigeria', value: 'Nigeria', icon: '🇳🇬' },
  { label: 'North Macedonia', value: 'North Macedonia', icon: '🇲🇰' },
  { label: 'Norway', value: 'Norway', icon: '🇳🇴' },
  { label: 'Oman', value: 'Oman', icon: '🇴🇲' },
  { label: 'Pakistan', value: 'Pakistan', icon: '🇵🇰' },
  { label: 'Palau', value: 'Palau', icon: '🇵🇼' },
  { label: 'Panama', value: 'Panama', icon: '🇵🇦' },
  { label: 'Papua New Guinea', value: 'Papua New Guinea', icon: '🇵🇬' },
  { label: 'Paraguay', value: 'Paraguay', icon: '🇵🇾' },
  { label: 'Peru', value: 'Peru', icon: '🇵🇪' },
  { label: 'Philippines', value: 'Philippines', icon: '🇵🇭' },
  { label: 'Poland', value: 'Poland', icon: '🇵🇱' },
  { label: 'Portugal', value: 'Portugal', icon: '🇵🇹' },
  { label: 'Qatar', value: 'Qatar', icon: '🇶🇦' },
  { label: 'Romania', value: 'Romania', icon: '🇷🇴' },
  { label: 'Russia', value: 'Russia', icon: '🇷🇺' },
  { label: 'Rwanda', value: 'Rwanda', icon: '🇷🇼' },
  { label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis', icon: '🇰🇳' },
  { label: 'Saint Lucia', value: 'Saint Lucia', icon: '🇱🇨' },
  { label: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines', icon: '🇻🇨' },
  { label: 'Samoa', value: 'Samoa', icon: '🇼🇸' },
  { label: 'San Marino', value: 'San Marino', icon: '🇸🇲' },
  { label: 'Sao Tome and Principe', value: 'Sao Tome and Principe', icon: '🇸🇹' },
  { label: 'Saudi Arabia', value: 'Saudi Arabia', icon: '🇸🇦' },
  { label: 'Senegal', value: 'Senegal', icon: '🇸🇳' },
  { label: 'Serbia', value: 'Serbia', icon: '🇷🇸' },
  { label: 'Seychelles', value: 'Seychelles', icon: '🇸🇨' },
  { label: 'Sierra Leone', value: 'Sierra Leone', icon: '🇸🇱' },
  { label: 'Singapore', value: 'Singapore', icon: '🇸🇬' },
  { label: 'Slovakia', value: 'Slovakia', icon: '🇸🇰' },
  { label: 'Slovenia', value: 'Slovenia', icon: '🇸🇮' },
  { label: 'Solomon Islands', value: 'Solomon Islands', icon: '🇸🇧' },
  { label: 'Somalia', value: 'Somalia', icon: '🇸🇴' },
  { label: 'South Africa', value: 'South Africa', icon: '🇿🇦' },
  { label: 'Spain', value: 'Spain', icon: '🇪🇸' },
  { label: 'Sri Lanka', value: 'Sri Lanka', icon: '🇱🇰' },
  { label: 'Sudan', value: 'Sudan', icon: '🇸🇩' },
  { label: 'Sudan, South', value: 'Sudan, South', icon: '🇸🇸' },
  { label: 'Suriname', value: 'Suriname', icon: '🇸🇷' },
  { label: 'Sweden', value: 'Sweden', icon: '🇸🇪' },
  { label: 'Switzerland', value: 'Switzerland', icon: '🇨🇭' },
  { label: 'Syria', value: 'Syria', icon: '🇸🇾' },
  { label: 'Taiwan', value: 'Taiwan', icon: '🇹🇼' },
  { label: 'Tajikistan', value: 'Tajikistan', icon: '🇹🇯' },
  { label: 'Tanzania', value: 'Tanzania', icon: '🇹🇿' },
  { label: 'Thailand', value: 'Thailand', icon: '🇹🇭' },
  { label: 'Togo', value: 'Togo', icon: '🇹🇬' },
  { label: 'Tonga', value: 'Tonga', icon: '🇹🇴' },
  { label: 'Trinidad and Tobago', value: 'Trinidad and Tobago', icon: '🇹🇹' },
  { label: 'Tunisia', value: 'Tunisia', icon: '🇹🇳' },
  { label: 'Turkey', value: 'Turkey', icon: '🇹🇷' },
  { label: 'Turkmenistan', value: 'Turkmenistan', icon: '🇹🇲' },
  { label: 'Tuvalu', value: 'Tuvalu', icon: '🇹🇻' },
  { label: 'Uganda', value: 'Uganda', icon: '🇺🇬' },
  { label: 'Ukraine', value: 'Ukraine', icon: '🇺🇦' },
  { label: 'United Arab Emirates', value: 'United Arab Emirates', icon: '🇦🇪' },
  { label: 'United Kingdom', value: 'United Kingdom', icon: '🇬🇧' },
  { label: 'United States', value: 'United States', icon: '🇺🇸' },
  { label: 'Uruguay', value: 'Uruguay', icon: '🇺🇾' },
  { label: 'Uzbekistan', value: 'Uzbekistan', icon: '🇺🇿' },
  { label: 'Vanuatu', value: 'Vanuatu', icon: '🇻🇺' },
  { label: 'Vatican City', value: 'Vatican City', icon: '🇻🇦' },
  { label: 'Venezuela', value: 'Venezuela', icon: '🇻🇪' },
  { label: 'Vietnam', value: 'Vietnam', icon: '🇻🇳' },
  { label: 'Yemen', value: 'Yemen', icon: '🇾🇪' },
  { label: 'Zambia', value: 'Zambia', icon: '🇿🇲' },
  { label: 'Zimbabwe', value: 'Zimbabwe', icon: '🇿🇼' },
];

export default COUNTRIES;
